import { playerIdFromQr } from './playerQr';

/**
 * What a scan at the front desk turned out to be.
 *
 * Two things get held up to that camera: a player's profile code, and the code on
 * their receipt. One scanner reads both, which only works if the payloads can be
 * told apart without asking the person which one they just showed you — so the
 * decision is made here, from the payload itself, and the desk simply acts on the
 * answer.
 *
 * Player codes are profile URLs (/player/<uuid>) and predate this. Order codes
 * are either a URL to the order or the order number written out, because a
 * one-dimensional barcode cannot hold a URL — it has room for the number and
 * nothing else.
 *
 * @returns {{type:'player', id:string} | {type:'order', number:string} | null}
 */
export const readScan = (text) => {
  const raw = String(text || '').trim();
  if (!raw) return null;

  const playerId = playerIdFromQr(raw);
  if (playerId) return { type: 'player', id: playerId };

  const url = raw.match(/\/orders?\/([A-Z0-9-]{8,})/i);
  if (url) return { type: 'order', number: url[1].toUpperCase() };

  // The number on its own: US-KSA-TRN-2608230001, or USR-TRN-2608230001 when no
  // academy is involved. Anchored, so a stray string of digits from some other
  // barcode on the same page cannot be mistaken for an order.
  if (/^(?:[A-Z]{2}-)?[A-Z]{3}-[A-Z]{3}-\d{10,}$/i.test(raw)
      || /^USR-[A-Z]{3}-\d{10,}$/i.test(raw)) {
    return { type: 'order', number: raw.toUpperCase() };
  }

  return null;
};

export default readScan;
